import { AxiosRequestConfig } from "axios";
import {
  GetChannelsRequest,
  GetChannelsResponse,
  ManageChannelRequest,
  ManageChannelResponse,
  ManageUserChannelRequest,
  ManageUserChannelResponse,
} from "models";
import service from "services";

// Manage channel
export const getChannels = async (
  params: GetChannelsRequest,
  config?: AxiosRequestConfig
) =>
  await service.get<GetChannelsResponse>("OmniSource/QueryOmniSource", {
    ...config,
    params,
  });

export const manageChannel = async (
  params: ManageChannelRequest,
  config?: AxiosRequestConfig
) =>
  await service.get<ManageChannelResponse>("OmniSource/ManagerOmniSource", {
    ...config,
    params,
  });

// Manage user channel
export const manageUserChannel = async (
  params: ManageUserChannelRequest,
  config?: AxiosRequestConfig
) =>
  await service.get<ManageUserChannelResponse>(
    "AttendGroup/ManagerAttendGroupUser",
    { ...config, params }
  );
